/**
 * 3대 AI 기능(리포트/계약서/제안서) 공통 이용권 API — tech_spec.md 8-3절
 * 결제는 웹(freematch.uk) 전용. 앱에서는 이 API의 purchase 계열을 호출하지 않는다.
 */
import axios from 'axios';
import { API_ORIGIN } from '../config/runtime';

export type AIToolType = 'report' | 'contract' | 'proposal';
export type AIPackageType = 'single' | 'bundle12';

const client = axios.create({ baseURL: `${API_ORIGIN}/api/ai-credits`, timeout: 15000 });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const aiCreditsAPI = {
  getConfig: async () => (await client.get('/config')).data,

  getBalances: async (): Promise<Record<AIToolType, number>> => {
    const res = await client.get('/balances');
    return res.data.data;
  },

  getBalance: async (toolType: AIToolType) => {
    const res = await client.get(`/balance/${toolType}`);
    return res.data.data.creditsRemaining as number;
  },

  preparePurchase: async (toolType: AIToolType, packageType: AIPackageType) => {
    const res = await client.post('/purchase/prepare', { toolType, packageType });
    return res.data.data as {
      orderId: string; amount: number; goodsName: string;
      clientId: string; customerEmail: string; returnUrl: string;
    };
  },
};

export default aiCreditsAPI;
